export default __webpack_public_path__ + "static/media/Kaem_Kirill_Vladimirovich.c42c5e81.webp";